export default from './comment-form-wrapper';



// WEBPACK FOOTER //
// ./app/components/comment-form-wrapper/index.js